"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI_MODELS_AUDIT_ACTION = exports.AI_MODEL_BUILT_IN_DEFAULTS = exports.AI_MODEL_SLOT_V2_FEATURES = exports.AI_MODEL_SLOT_INFO = exports.AI_DEPLOYMENT_NAME_MAX = exports.AI_DEPLOYMENT_NAME_PATTERN = exports.AI_MODEL_SLOTS = void 0;
exports.isAiDeploymentName = isAiDeploymentName;
exports.aiModelSlotFeatures = aiModelSlotFeatures;
/**
 * App Settings → AI models: which Azure AI deployment each AI feature uses on THIS install.
 * A choice saved there wins over the install's AZURE_OPENAI_DEPLOYMENT_* env var; nothing saved = the
 * env var, exactly as before. The server resolves (apps/api/src/ai-models/resolve-ai-models.ts); the
 * browser only ever sees what the server reports, because it cannot read the container's environment.
 */
exports.AI_MODEL_SLOTS = ['composer', 'strategist', 'digest', 'embeddings', 'image'];
/**
 * A deployment name the app will put in a request URL. The OpenAI SDK places it in the path UNENCODED
 * (node_modules/openai/index.js:244): a leading letter/digit and this alphabet rule out '/', '?', '%',
 * spaces and a '..' segment ('x/../../files?y=' reached /openai/files in a local test).
 */
exports.AI_DEPLOYMENT_NAME_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._-]*$/;
exports.AI_DEPLOYMENT_NAME_MAX = 64;
function isAiDeploymentName(value) {
    return value.length <= exports.AI_DEPLOYMENT_NAME_MAX && exports.AI_DEPLOYMENT_NAME_PATTERN.test(value);
}
exports.AI_MODEL_SLOT_INFO = {
    composer: {
        label: 'Content Composer', envVar: 'AZURE_OPENAI_DEPLOYMENT_CHAT', note: null,
        // ai.service.ts:85, thread-convert.service.ts:167, post-prompt.service.ts:79, refine-design.service.ts:306.
        // With Brand Workspace v2 on, also AI_MODEL_SLOT_V2_FEATURES.composer.
        features: ['AI Assist', 'Convert to thread with AI', 'Generate text or an image prompt from your post', 'Design refinement'],
    },
    strategist: {
        label: 'Strategist', envVar: 'AZURE_OPENAI_DEPLOYMENT_STRATEGIST', note: null,
        // strategist.service.ts:921, :2297; scheduling.service.ts:504; brand-guidelines.service.ts:135.
        features: ['Content Strategist chat', 'Conversation titles', 'Best time to post reasons', 'Brand guidelines upload'],
    },
    digest: {
        label: 'Social Digest', envVar: 'AZURE_OPENAI_DEPLOYMENT_DIGEST', note: null,
        // brief-generator.ts:225, :234; trend-topics.service.ts:211
        features: ['Social Digest themes', 'Trend Topic suggestions'],
    },
    embeddings: {
        label: 'Embeddings', envVar: 'AZURE_OPENAI_DEPLOYMENT_EMBEDDINGS', features: [],
        note: 'Not used by any feature yet.', // ai.service.ts:96-98 has no caller
    },
    image: {
        label: 'Image generation', envVar: 'AZURE_OPENAI_DEPLOYMENT_IMAGE', note: null,
        // media-generation.service.ts:424, :465; design-engine/image-provider.service.ts:97
        features: ['Generate media: Smorgas Social · FLUX', 'Design background images'],
    },
};
/**
 * The features a slot also drives on an install with Brand Workspace v2 on, listed after its `features`
 * only there. An install with the flag off has no Brand Setup, and meets the legacy migration only as the
 * operator steps of docs/brand-migration-runbook.md (its dry run and apply do call this slot), so its AI
 * models card names neither: Releases 3 and 4 change nothing a person sees on such an install.
 * brand-import/extraction/brand-extraction.service.ts (BRAND_EXTRACTION_PURPOSE) reads Brand Setup's
 * documents and the legacy brand migration's text on the Content Composer slot (on the Strategist slot
 * until 2026-10-31). Release 4 reads web pages and Revisit's re-reads through the same engine, and makes
 * AI suggestions on the same slot (brand-suggestions/brand-suggestions.service.ts, BRAND_SUGGESTIONS_PURPOSE).
 */
exports.AI_MODEL_SLOT_V2_FEATURES = {
    composer: [
        'Brand Setup document import',
        'Brand Setup web page scan',
        'Brand Setup AI suggestions',
        'Brand Setup re-read',
        'Legacy brand migration',
    ],
};
/** What a slot drives on this install: `features`, then the Brand Workspace v2 ones when the flag is on. */
function aiModelSlotFeatures(slot, brandWorkspaceV2) {
    const base = exports.AI_MODEL_SLOT_INFO[slot].features;
    return brandWorkspaceV2 ? [...base, ...(exports.AI_MODEL_SLOT_V2_FEATURES[slot] ?? [])] : base;
}
/** When neither App Settings nor the env var names one. Strategist and Digest have none of their own:
 *  they follow Content Composer. Image: none, so off. Equal to configuration.ts:168 / :251-254 today. */
exports.AI_MODEL_BUILT_IN_DEFAULTS = {
    composer: 'gpt-4.1', strategist: null, digest: null, embeddings: 'text-embedding-3-large', image: null,
};
exports.AI_MODELS_AUDIT_ACTION = 'platform-settings.ai-models.update';
//# sourceMappingURL=ai-models.js.map